{
  "title": "Support",
  "description": "Your tickets with bPanel support, plus links to the docs and service status.",
  "new": {
    "title": "New ticket",
    "description": "Describe the problem and pick the server; we reply right here.",
    "button": "New ticket",
    "created": "Ticket {{number}} opened",
    "submit": "Send ticket",
    "steps": {
      "details": "Problem details",
      "diagnostics": "Diagnostics and send"
    },
    "fields": {
      "category": "Request type",
      "server": "Server",
      "priority": "Priority",
      "subject": "Subject",
      "body": "Description"
    },
    "noServer": "No specific server",
    "subjectPlaceholder": "For example: backups fail on server2",
    "bodyHint": "Say what you expected, what happened and when it started. Details shorten the fix.",
    "review": "Review your ticket"
  },
  "ticket": {
    "title": "Ticket",
    "description": "The conversation with support.",
    "reopen": "Reopen ticket",
    "close": "Close ticket",
    "awaitingUs": "Waiting on our reply. First reply target for this priority: {{target}}",
    "details": "Ticket details",
    "number": "Ticket number",
    "openedBy": "Opened by",
    "opened": "Opened",
    "assignee": "Handled by",
    "unassigned": "Waiting to be assigned",
    "resolved": "Resolved",
    "closeTitle": "Close this ticket?",
    "closeDescription": "We'll treat the problem as solved. You can reopen it or reply within 14 days.",
    "replyReopen": "Reply to reopen the ticket",
    "reply": "Your reply",
    "message": "Message",
    "messageRequired": "Write your reply first",
    "placeholder": "Write your reply to support",
    "send": "Send reply",
    "back": "All tickets"
  },
  "list": {
    "caption": "Support tickets",
    "search": "Search by subject or number",
    "columns": {
      "subject": "Subject",
      "server": "Server",
      "category": "Type",
      "priority": "Priority",
      "status": "Status",
      "updated": "Updated"
    },
    "noServer": "No server",
    "empty": {
      "title": "No tickets yet",
      "body": "If you need help with a server, an invoice or a move from cPanel, open a ticket and we'll reply here."
    },
    "waitingOnYou_one": "1 ticket is waiting on your reply.",
    "waitingOnYou_other": "{{count}} tickets are waiting on your reply.",
    "waitingOnYou_zero": "No tickets are waiting on you."
  },
  "status": {
    "open": "Open",
    "waiting_on_customer": "Waiting on you",
    "waiting_on_support": "Waiting on us",
    "resolved": "Resolved"
  },
  "priority": {
    "low": {
      "label": "Low",
      "when": "A general question or request with no impact on sites.",
      "target": "First reply within 2 business days"
    },
    "normal": {
      "label": "Normal",
      "when": "Something isn't working as it should, and sites are up.",
      "target": "First reply within 1 business day"
    },
    "high": {
      "label": "High",
      "when": "A feature is broken for several accounts, or the server is clearly slow.",
      "target": "First reply within 8 hours"
    },
    "urgent": {
      "label": "Urgent",
      "when": "Sites or mail are down on a server.",
      "target": "First reply within 2 hours, every day"
    },
    "note": "Business days are Sunday to Thursday, Riyadh time. We hold ourselves to these targets. We may change the priority after reading the ticket, and we'll tell you why."
  },
  "category": {
    "technical": {
      "label": "Technical problem",
      "hint": "The server, the panel, sites or mail"
    },
    "billing": {
      "label": "Billing",
      "hint": "Invoices, payments and VAT",
      "tip": "For invoices and payments we don't need data from the server. Include the invoice number if you have it."
    },
    "migration": {
      "label": "Moving from cPanel",
      "hint": "Moving accounts, sites and mail",
      "tip": "Tell us how many accounts you have, their rough size and when suits you, and we'll prepare a move plan."
    },
    "licensing": {
      "label": "Licensing and activation",
      "hint": "Activation key, subscription status and installation"
    },
    "other": {
      "label": "Other",
      "hint": "Anything else"
    }
  },
  "help": {
    "title": "Other resources",
    "docs": {
      "title": "Documentation",
      "body": "Guides for installing, moving from cPanel and backups. Being written now."
    },
    "status": {
      "title": "Service status",
      "body": "Status of the licence, update and AI services. The status page is being set up."
    }
  },
  "attachments": {
    "label": "Attachments",
    "add": "Attach a file",
    "hint": "Up to 5 files, 10 MB each: images, PDF, text and ZIP.",
    "remove": "Remove {{name}}",
    "tooMany": "Up to 5 files.",
    "tooLarge": "{{name}} is larger than 10 MB.",
    "none": "No attachments",
    "demo": "Files in the demo are for show only",
    "count_one": "1 file",
    "count_other": "{{count}} files",
    "count_zero": "No files"
  },
  "diagnostics": {
    "title": "Diagnostics",
    "intro": "Technical data from the server that helps support understand the problem faster. Sharing is optional, and this is exactly what we receive.",
    "noServer": "You didn't pick a server, so there are no diagnostics to share. You can go back and pick one.",
    "notAllowed": "Your role is {{role}}; sharing is open to the owner, admins and technical members.",
    "notInstalled": "{{host}} hasn't checked in yet, so there are no diagnostics.",
    "share": "Share diagnostics from {{host}}",
    "shareHint": "We capture the data now and attach it to the ticket. It doesn't update afterwards.",
    "previewOn": "This is what we share",
    "previewOff": "This is what we'd share if you turn sharing on",
    "collected": "From {{host}}, {{when}}",
    "versions": "Versions",
    "channel": "Update channel",
    "os": "Operating system",
    "kernel": "Kernel",
    "subscription": "Subscription",
    "plan": "Plan",
    "lastCheckIn": "Last check-in",
    "never": "Not yet",
    "graceUntil": "Grace until",
    "jobTypes": {
      "backup": "Backup",
      "ssl_renewal": "SSL renewal",
      "update": "bPanel update",
      "migration": "Move from cPanel",
      "mail_queue": "Mail queue",
      "dns_sync": "DNS sync"
    },
    "noFailures": "No failed jobs in the last 7 days.",
    "services": "Services",
    "serviceState": {
      "running": "running",
      "stopped": "stopped",
      "degraded": "has a problem"
    },
    "neverTitle": "What we never share",
    "excluded": {
      "domains": "Domain and site names",
      "emails": "Email addresses and message content",
      "accounts": "Hosting account names and your customers' data",
      "files": "Files and site content",
      "databases": "Databases and their content",
      "logs": "Access logs and site logs",
      "visitors": "Visitors' IP addresses",
      "secrets": "Passwords and keys"
    },
    "showRaw": "Show the data as sent",
    "hideRaw": "Hide the data",
    "sharedOn": "Shared from {{host}}, {{when}}",
    "view": "View diagnostics",
    "notShared": "No diagnostics were shared with this ticket.",
    "drawerDescription": "The snapshot support received with the ticket.",
    "failures_one": "Failed jobs in the last 7 days (1)",
    "failures_other": "Failed jobs in the last 7 days ({{count}})",
    "failures_zero": "Failed jobs in the last 7 days",
    "attempts_one": "1 attempt",
    "attempts_other": "{{count}} attempts"
  },
  "thread": {
    "label": "Conversation",
    "staff": "bPanel support, {{team}}",
    "events": {
      "status": "Status changed to: {{status}}",
      "priority": "Priority changed to: {{priority}}",
      "diagnostics": "Diagnostics shared from {{host}}",
      "rated": "You rated support {{score}} out of 5"
    }
  },
  "staffTeams": {
    "support": "Technical support",
    "migration": "Migration team",
    "billing": "Billing"
  },
  "rating": {
    "title": "How was your experience with support?",
    "description": "Your rating goes to the support team.",
    "thanks": "Thanks for your rating",
    "yourScore": "You rated {{score}} out of 5",
    "labels": {
      "1": "Very poor",
      "2": "Poor",
      "3": "Okay",
      "4": "Good",
      "5": "Excellent"
    },
    "comment": "Comment",
    "submit": "Send rating"
  },
  "toasts": {
    "closed": "Ticket closed",
    "reopened": "Ticket reopened",
    "rated": "Thanks, we got your rating"
  }
}
